angular.module('bmsApp.settings')
	.controller('BookingPromptCtrl', BookingPromptCtrl);

BookingPromptCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'notify',
	'LicenseOptionsSvc',
	'LicenseDetailSvc',
];

function BookingPromptCtrl(
	$scope,
	$state,
	$q,
	notify,
	LicenseOptionsSvc,
	LicenseDetailSvc,
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		options: {},
		processing: false,
	});

	this.$onInit = () => {
		self.loading = true;
		let promises = {
			licenses: LicenseOptionsSvc.license().then((response) => {
				self.options.licenses = response.data.options;
				self.loading = false;
			})
		};
	};

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.licenseChanged = () => {
		LicenseDetailSvc.read(self.license.id).then((response) => {
			self.license = response.data.license;
		});
	};

	handlers.submitClick = () => {
		self.processing = true;
		LicenseDetailSvc.saveBookingPrompt(self.license).then((response) => {
			notify({
				message: 'Booking prompt updated',
			});
			self.processing = false;
		});
	};
}
